export const getApiUrlLocale = locale => {
  if (locale === "cn") {
    return "zh-CN"
  }
  if (locale === "tw") {
    return "zh-Hant"
  }
  return locale
}

export const getLocaleRoute = locale => {
  if (locale === "zh-CN") {
    return "cn"
  }
  if (locale === "zh-Hant") {
    return "tw"
  }
  return locale
}
